import { motion } from 'framer-motion';
import { CompassLogo } from './CompassLogo';

export const TypingIndicator = () => {
  const dotVariants = {
    start: { y: 0 },
    end: { y: -10 },
  };

  const dotTransition = {
    duration: 0.5,
    repeat: Infinity,
    repeatType: 'reverse' as const,
    ease: 'easeInOut' as const,
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="flex items-start gap-3"
      data-testid="typing-indicator"
    >
      {/* Compass Logo */}
      <div className="shrink-0 pt-1">
        <CompassLogo size={32} />
      </div>

      {/* Thinking indicator */}
      <div className="flex flex-col gap-2 flex-1 items-start">
        <p className="text-zinc-500 dark:text-zinc-400 text-[13px] font-medium leading-normal px-1">
          Compass
        </p>

        <div
          className="flex items-center space-x-1.5 px-1 mt-3"
          role="status"
          aria-label="Assistant is typing"
        >
          <motion.div
            className="w-2 h-2 bg-zinc-500 dark:bg-zinc-400 rounded-full"
            variants={dotVariants}
            initial="start"
            animate="end"
            transition={{ ...dotTransition, delay: 0 }}
          />
          <motion.div
            className="w-2 h-2 bg-zinc-500 dark:bg-zinc-400 rounded-full"
            variants={dotVariants}
            initial="start"
            animate="end"
            transition={{ ...dotTransition, delay: 0.2 }}
          />
          <motion.div
            className="w-2 h-2 bg-zinc-500 dark:bg-zinc-400 rounded-full"
            variants={dotVariants}
            initial="start"
            animate="end"
            transition={{ ...dotTransition, delay: 0.4 }}
          />
        </div>
      </div>
    </motion.div>
  );
};
